import React from 'react'

export default function ProductsListInnerStyle({signed_in}) {
  // let display_item_buttons = 'flex' // default to flex which means it's an Admin
  // if (signed_in !== 'admin') display_item_buttons = (signed_in.user_access.products_fc) ? 'flex' : 'none'

  let display_item_buttons = 'visible' // default to flex which means it's an Admin
  if (signed_in !== 'admin') display_item_buttons = (signed_in.user_access.products_fc) ? 'visible' : 'hidden'
  return (
    <React.Fragment>
      <style jsx="true">
      {`
        #data-row-container {
          /*border: solid lightgrey 1px;*/
          overflow: auto;
        }

        .data-row {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: stretch;
          margin-bottom: 20px;
          border: solid 0.5px indigo;
        }

        .item-name {
          font-size: 0.65em;
          font-weight: bold;
          /*color: floralwhite;*/
          /*color: rgba(22, 22, 22, 0.8);*/
          /*color: whitesmoke;*/
          color: #EDF1FF;
          height: 100%;
          margin: auto;
          flex: 7;
        }

        .item-id {
          font-size: 0.6em;
        }

        .item-name-and-id {
          padding: 5px 5px;
          border-top: dotted lightgrey 1px;
          display: flex;
          /*background-color: rgba(21, 134, 237, 1);*/
          /*background-color: rgba(181, 230, 29, 1);*/
          /*background-color: rgba(195, 195, 195, 1);*/
          /*background-color: #0072B5; // French Blue  */
          background-color: #00758F; // Mosaic Blue
          /*background-color: #282D3C;*/ /* Navy Blazer */
          align-items: center;
        }

        .item-buttons {
          visibility: ${display_item_buttons};
          /*display: ${display_item_buttons};*/
          display: flex;
          height: 100%;
          margin: auto;
          flex: 1;
          /*justify-content: space-around;*/
          justify-content: flex-end;
          align-items: center;
        }
        .item-checkbox {
          maring-right: 10px;
        }
        .dd-window-container {
          position: absolute;
          width: 10%;
          top: 35px;
          /*box-shadow: 1px 1px 2px 1px #BBB;*/
          /*box-shadow: 1px 1px 2px 1px rgba(195, 195, 195, 1);*/
          /*left: -10%;*/
        }
        .item-buttons .item-option-drop {
          /* color: #EDF1FF; // Brilliant White */
          background-color: transparent;
          color: #A09998; /* Brilliant White */
        }
        .item-buttons .item-option-drop:hover {
          /*background-color: transparent;*/
          color: white;
        }
        .item-buttons item-option-drop:focus {
          /*background-color: transparent;*/
          color: white;
        }

        /*
        .item-buttons button {
          text-decoration: underline;
          border: none;
          background: none;
          padding: 5px;
          color: black;
          border: solid 0.5px transparent;
        }

        .item-buttons button:hover {
          cursor: pointer;
          color: whitesmoke;
          border: solid 0.5px lightgreen;
        }
        */

        .table-unit-details {
          border: solid 1px lightgreen;
          border-left: none;
          border-right: none;
          font-size: 0.7em;
          border-spacing: 0;
          width: 100%;
        }

        .table-unit-details th {
          font-size: 0.9em;
          text-align: left;
          padding: 5px;
        }

        .table-unit-details td {
          font-size: 0.9em;
          text-align: left;
          padding: 5px;
        }

        .table-unit-details th:nth-child(1), .table-unit-details td:nth-child(1) {
          width: 15%;
        }
        .table-unit-details th:nth-child(2), .table-unit-details td:nth-child(2) {
          width: 28%;
        }
        .table-unit-details th:nth-child(3), .table-unit-details td:nth-child(3) {
          width: 5%;
        }
        .table-unit-details th:nth-child(4), .table-unit-details td:nth-child(4) {
          width: 15%;
        }
        .table-unit-details th:nth-child(5), .table-unit-details td:nth-child(5) {
          width: 15%;
        }
        .table-unit-details th:nth-child(6), .table-unit-details td:nth-child(6) {
          width: 10%;
        }
      `}
      </style>
    </React.Fragment>
  )
}
